import Vue from 'vue'

import {
    Tabs,
    Icon,
    Stepper,
    Swipe,
    SwipeItem,
    Popup,
    Tab,
    Button,
    Form,
    Field,
    Picker,
    Toast,
    Dialog,
    List,
    Cell,
    Collapse,
    Search,
    CollapseItem,
    ImagePreview,
    CellGroup,
    Uploader,
    Badge,
    Divider,
    ActionSheet,
    Loading,
    Skeleton
} from 'vant'
Vue.use(Collapse)
Vue.use(ActionSheet)
Vue.use(Divider)
Vue.use(CellGroup)
Vue.use(Uploader)
Vue.use(Search)
Vue.use(Loading)
Vue.use(CollapseItem)
Vue.use(Tabs)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)
Vue.use(Badge)
Vue.use(Stepper)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Picker)
Vue.use(List)
Vue.use(Cell)
Vue.use(Skeleton)
Vue.prototype.$message = Toast
Vue.prototype.$confirm = Dialog.confirm
Vue.prototype.$imgPreview = ImagePreview
Vue.prototype.$alert = Dialog.alert
Vue.prototype.$errorHandler = error => {
    let msg
    if (error instanceof Error) {
        msg = error.message
    } else {
        msg = error
    }
    Toast.fail(msg)
}
Toast.allowMultiple()